import { postProductLike as postProductLikeApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  PostProductLikeRequestSchema,
  PostProductLikeResponseDataSchema,
  type PostProductLikeServiceRequest,
  type PostProductLikeServiceResponse,
} from './product-like.dto';

export const postProductLikeService = withServiceErrorCapture(
  lazyPipe(
    // 1. Validate the incoming request object against a Zod schema.
    validateServiceRequest(PostProductLikeRequestSchema),

    // 2. Execute the core business logic. This is where you call the API Layer,
    //    transform data, and perform the main task of the service.
    async (request: PostProductLikeServiceRequest): Promise<PostProductLikeServiceResponse> => {
      const apiResponse = await postProductLikeApi({
        goodsNo: Number(request.goodsNo),
        action: request.isLiked === true ? 'LIKE' : 'UNLIKE',
      });

      // Transform API response to service response DTO
      return {
        success: apiResponse.meta?.result === 'SUCCESS',
      };
    },

    // 3. Validate the final response object before it is returned.
    validateServiceResponse(PostProductLikeResponseDataSchema),
  ),
);
